import { render, staticRenderFns } from "./SuperAdminVerifyMobile.vue?vue&type=template&id=23dda47d&scoped=true&"
import script from "./SuperAdminVerifyMobile.vue?vue&type=script&lang=js&"
export * from "./SuperAdminVerifyMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dda47d",
  null
  
)

export default component.exports